import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactModal from 'react-modal';
import InputMask from 'react-input-mask';
import { TbSearch } from 'react-icons/tb';
import { RiCloseLine, RiSearchLine } from 'react-icons/ri';
import { IoClose } from 'react-icons/io5';

import { useAuth } from 'context/AuthContext';
import Box from 'components/ui/box';
import { UserAvatar } from 'components/user-avatar';
import { findGestor, findManagers, updateUserByIdProfile } from 'services/profile.service';

import { User, UserInfo } from 'types/user';

import FeedbackImg from 'assets/img/comportamento/bg-feedback-moedas.old.png';
import { getPlayerInfo } from 'services/dashboard.service';
import Button from 'components/ui/button';
import { IoIosClose } from 'react-icons/io';
import { AiOutlineEdit } from 'react-icons/ai';

const maskTemplate = 'F9999999';

interface IProps {
  closeModal: () => void;
  onSubmit: (item: any) => void;
  player: any;
}

export default function SelectGestor({ closeModal, player, onSubmit }: IProps) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const searchRef = useRef<any>();

  const [isOpen, setIsOpen] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [userEdit, setUserEdit] = useState<UserInfo>();
  const [target, setTarget] = useState<User[]>();
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [step, setStep] = useState(0);
  const [mask, setMask] = useState('');
  const [initialManager, setInitialManager] = useState<any>();
  const [searchManager, setSearchManager] = useState<string>('');

  ReactModal.setAppElement('#modal');

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  async function handleSearchManager(e?: any) {
    if (e) {
      e.preventDefault();
    }

    try {
      setSearching(true);

      const result = await findManagers(searchManager, player.cod, true);

      const filteredResults = result.filter((item: any) => item._id !== user?._id);

      setSearchResults(filteredResults);

      setSearching(false);
    } catch (e) {
      setSearching(false);
    }
  }

  function removeTarget(index: number) {
    if (target && target.length) {
      const newTargetList = [...target];
      newTargetList.splice(index, 1);
      setTarget(newTargetList);
    }
  }

  function addTarget(item: User) {
    setTarget([item]);
    setSearchResults([]);
    setSearching(false);

    if (searchRef && searchRef.current) {
      searchRef.current.value = '';
    }
  }

  function reset() {
    setTarget(undefined);
    setSubmitted(false);
    setLoading(false);
    setSearchResults([]);
    setSearching(false);
    setStep(0);
    setUserEdit(undefined);
  }

  function handleCloseModal() {
    reset();
    closeModal();
  }

  function afterOpenModal() {}

  useEffect(() => {
    async function getUser() {
      const resp = await getPlayerInfo('F' + player?.gestor?.padStart(7, '0'));
      if (resp) {
        setInitialManager(resp);
      }
    }

    if (player?.gestor) {
      getUser();
    }
  }, [player]);

  function isSwitchable() {
    if (!!initialManager?._id) return true;

    return false;
  }

  return (
    <ReactModal
      key={'modal-player-get-player'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Convidar Amigos"
      portalClassName="modal-player-get-player"
      overlayClassName="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
      contentElement={() => (
        <>
          {!submitted && !confirm && (
            <Box className="w-[90%] lg:max-w-screen-md">
              <button
                className="absolute w-[33px] h-[33px] flex items-center justify-center -top-4 -right-4 button-close bg-slate-blue rounded-full"
                onClick={() => {
                  if (loading) return null;

                  if (searchResults.length > 0) {
                    reset();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <IoClose size={23} className="text-white leading-none block m-0 p-0" />
              </button>

              <div className="mx-auto relative container overflow-y-auto overflow-x-hidden max-h-[85vh]">
                <div className="block mb-8">
                  <h1 className="text-lg uppercase block text-center text-yellow">Confirme o gestor da próxima etapa</h1>
                </div>

                {!loading && !submitted && (
                  <div className="space-y-6">
                    {/* <div className="relative flex flex-row items-center justify-around">
                      <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-white opacity-20"></div>
                      <div className={`${step === 0 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'} text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}>1</div>
                      <div className={`${step === 1 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'} text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}>2</div>
                    </div> */}

                    {step === 0 && (
                      <div className="space-y-6">
                        <div className="space-x-4 flex flex-row items-center justify-between w-full">
                          <div className="relative flex-1">
                            <span className="text-alice-blue mb-4 block text-base font-thin">
                              Responsável por apreciar a realização
                            </span>

                            <div className="flex space-x-3">
                              <form onSubmit={handleSearchManager} className="pl-1 flex-1">
                                <input
                                  value={
                                    !!initialManager
                                      ? `${initialManager.nome_guerra} (${initialManager.chave}) - ${initialManager.funcao}`
                                      : searchManager
                                  }
                                  disabled={!!initialManager}
                                  onChange={e => setSearchManager(e.target.value)}
                                  className={`text-white w-full bg-maastricht-blue  py-2 px-4 rounded-md leading-none text-sm font-light`}
                                />
                              </form>

                              {!!initialManager ? (
                                <button onClick={() => setInitialManager(null)}>
                                  <AiOutlineEdit className="text-grey-dark" size={25} />
                                </button>
                              ) : (
                                <button onClick={() => handleSearchManager()}>
                                  <RiSearchLine className="text-grey-dark" size={25} />
                                </button>
                              )}
                            </div>

                            <span className="text-yellow text-xs mt-4 pl-1 block">
                              Essa pessoa é responsável por realizar a apreciação desta entrega? Caso não seja ela, você pode
                              alterá-la, clicando no ícone acima.
                              <br />
                              <br />
                              Atenção: Não deve ser indicado novo líder nas situações em que o seu gestor tenha ausência
                              temporária (férias, abonos, licença paternidade, folgas, viagem a serviço, licença saúde até 15
                              (quinze) dias etc.).
                            </span>
                          </div>
                        </div>

                        {target && target?.length > 0 && !searching && (
                          <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-2 lg:px-8 rounded-3xl">
                            {target.map((item: User, index: number) => (
                              <div
                                key={item._id}
                                className={`w-full flex flex-col lg:flex-row lg:items-center justify-between ${
                                  index + 1 < target.length ? 'border-b border-prussian-blue pb-4 mb-4 ' : ''
                                }`}
                              >
                                <div className="flex flex-1 relative">
                                  <div className="w-[44px] h-[44px] ml-2">
                                    <UserAvatar
                                      data={{
                                        image: item.image,
                                        ...item,
                                      }}
                                    />
                                  </div>

                                  <p className="flex-1 pl-3 pr-2">
                                    <span className="block text-xs font-thin">
                                      <strong className="text-base font-semibold">{item.nome_guerra}</strong>
                                    </span>

                                    <span className="text-xs font-thin w-full">
                                      <strong className="text-base font-semibold lg:truncate w-[35vw] lg:w-auto">
                                        {item.nome}
                                      </strong>{' '}
                                      ({item._id})
                                    </span>
                                    {!!item?.diretoria || !!item?.funcao ? (
                                      <span className="block text-xs font-thin">
                                        {!!item?.diretoria && (
                                          <span className="text-electric-blue uppercase">{item?.diretoria}</span>
                                        )}
                                        {!!item?.diretoria && !!item?.funcao && ' - '}
                                        {item?.funcao ? `${item?.funcao}` : ''}
                                      </span>
                                    ) : null}
                                  </p>
                                </div>

                                <RiCloseLine
                                  size={44}
                                  className="cursor-pointer hover:ring-2 p-2 rounded-full text-slate-blue"
                                  onClick={() => removeTarget(index)}
                                />
                              </div>
                            ))}
                          </div>
                        )}

                        {searching && (
                          <div className="flex-1 bg-rich-black bg-opacity-80 p-8 rounded-3xl">
                            <p className="animate-pulse text-yellow">Recuperando informações...</p>
                          </div>
                        )}

                        {!searching && !!searchResults?.length && (
                          <>
                            <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl h-[30vh] lg:h-auto overflow-y-auto lg:overflow-y-visible">
                              {searchResults.map((item, index) => (
                                <div
                                  key={item._id}
                                  onClick={() => {
                                    setInitialManager(item);
                                    setSearchResults([]);
                                    setSearchManager('');
                                  }}
                                  className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4`}
                                >
                                  <div className="w-[44px] h-[44px] ml-2">
                                    <UserAvatar
                                      data={{
                                        image: item.image,
                                        ...item,
                                      }}
                                    />
                                  </div>
                                  <p className="flex-1 pl-3 pr-2">
                                    <span className="text-xs font-thin">
                                      <strong className="text-base font-semibold">{item.nome}</strong> ({item._id})
                                    </span>
                                    {!!item?.diretoria || !!item?.funcao ? (
                                      <span className="block text-xs font-thin">
                                        {!!item?.diretoria && (
                                          <span className="text-electric-blue uppercase">{item?.diretoria}</span>
                                        )}
                                        {!!item?.diretoria && !!item?.funcao && ' - '}
                                        {item?.funcao ? `${item?.funcao}` : ''}
                                      </span>
                                    ) : null}
                                  </p>
                                </div>
                              ))}

                              <div className="text-center pt-2 text-white font-base font-light">
                                Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    <div className="flex lg:block justify-center">
                      <div className="px-2 px-45 flex flex-row space-x-8 items-center justify-center">
                        {step === 0 && (
                          <div className="space-y-6">
                            {!isSwitchable() && !!target?.length && (
                              <p className="block font-light text-yellow text-center">
                                O novo gestor a ser indicado deve pertencer ao nível hierárquico superior ao do funcionário em
                                questão.
                              </p>
                            )}
                            <button
                              disabled={!isSwitchable()}
                              onClick={() => {
                                onSubmit(initialManager);
                              }}
                              className={`mx-auto mb-2 leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                            >
                              <p className="font-bold text-sm leading-none uppercase">Confirmar gestor</p>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {loading && !submitted && (
                  <div className="space-y-4 mt-12">
                    <div className="flex flex-row items-center justify-center text-xl text-yellow animate-pulse">
                      <div></div>
                      Mudando gestor...
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}
        </>
      )}
    />
  );
}
